import { render, staticRenderFns } from "./SaleProforma.vue?vue&type=template&id=a58552cc"
import script from "./SaleProforma.vue?vue&type=script&lang=js"
export * from "./SaleProforma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports